import { IGeoAddress } from "common/types";
import { useAddressAutosuggest } from "common/hooks/autosuggest";

import TextInput, { TextInputProps } from "./TextInput";

import "../../styles/AddressAutosuggestInput.less";

type AddressAutosuggestInputProps = {
  onAddressSelect: (address: IGeoAddress) => void;
} & TextInputProps;

const AddressAutosuggestInput = (props: AddressAutosuggestInputProps) => {
  const { onAddressSelect, ...other } = props;
  const inputRef = useAddressAutosuggest({ onAddressSelect });
  return <TextInput {...other} ref={inputRef} />;
};

export default AddressAutosuggestInput;
